import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { BasketStore, HasBasketGuard } from '@basket';
import { HasSelectedApplianceGuard } from '@registration';
import { QuoteTvOptimisation } from '../core/tracking/models/quote-tv-optimisation.enum';
import { SinglePlanFeatureFlagVariants } from '../core/tracking/models/single-plan-feature-flag-variants.enum';
import { errorRoutes, supportRoutes } from './shared-routes';
import { loadComponentByFeatureFlag } from './utils/feature-flag-route-loader.util';

export const appRoutes: Routes = [
  {
    path: 'appliance-details',
    loadComponent: () =>
      import('@features/appliance-details').then(
        (module) => module.HomepageComponent,
      ),
  },
  {
    path: 'protection-details',
    loadComponent: loadComponentByFeatureFlag(
      SinglePlanFeatureFlagVariants.QuoteTvOptimisation,
      [
        {
          variant: QuoteTvOptimisation.Variant,
          isEligible: () =>
            ['LY', 'CT', 'UT'].includes(
              inject(BasketStore).applianceDetails()?.applianceCode ?? '',
            ),
          loader: () =>
            import('@features/single-plan').then(
              (module) => module.SinglePlanSaleTvOptimisationComponent,
            ),
        },
      ],
      () =>
        import('@features/single-plan').then(
          (module) => module.SinglePlanSaleComponent,
        ),
    ),
    canActivate: [HasBasketGuard],
  },
  {
    path: 'contact-details',
    loadComponent: () =>
      import('@features/checkout').then(
        (module) => module.ContactDetailsComponent,
      ),
    canActivate: [HasSelectedApplianceGuard],
  },
  {
    path: 'direct-debit',
    loadComponent: () =>
      import('@features/checkout').then((module) => module.CheckoutComponent),
    canActivate: [HasBasketGuard],
  },
  {
    path: 'registration-confirmation',
    loadComponent: () =>
      import('@features/registration-confirmation').then(
        (module) => module.RegistrationConfirmationComponent,
      ),
  },
  {
    path: 'order-confirmation',
    loadComponent: () =>
      import('@features/order-confirmation').then(
        (module) => module.OrderConfirmationComponent,
      ),
  },
  ...errorRoutes,
  ...supportRoutes,
  {
    path: '**',
    redirectTo: 'appliance-details',
    pathMatch: 'full',
  },
];
